import { render, staticRenderFns } from "./bill-batch.vue?vue&type=template&id=4191324c&scoped=true"
import script from "./bill-batch.vue?vue&type=script&lang=ts"
export * from "./bill-batch.vue?vue&type=script&lang=ts"
import style0 from "./bill-batch.vue?vue&type=style&index=0&id=4191324c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4191324c",
  null
  
)

export default component.exports